import { Component } from '@angular/core';

import { environment } from '../environments/environment';
import Logger from './shared/logger';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor() {
        Logger.info(`Vuframe® SharePage v${environment.version}`);
    }
}
